import React, { useState } from "react";
import MarkingClassesContext from "./MarkingClassesContext";

const MarkingClassesProvider = ({ children }) => {
  const [viewSelector, setViewSelector] = useState('logs');

  return (
    <MarkingClassesContext.Provider
      value={{
        viewSelector,
        setViewSelector,
      }}
    >
      {children}
    </MarkingClassesContext.Provider>
  );
};

export default MarkingClassesProvider;

